import React from "react";
import styles from "./BannerWebsite.module.scss";
import { useNavigate } from "react-router-dom";

const BannerWebsite = () => {
  const navigate = useNavigate();

  // The banner is the first thing painted, so it is fetched eagerly at high
  // priority, sized for the screen (it never renders wider than 1500px), and
  // given its intrinsic size so the page below it does not jump when it lands.
  return (
    <div onClick={() => navigate('quality-authenticity')} className={styles.banner_wrapper}>
      <picture>
        <source
          type="image/webp"
          srcSet="/banner/banner-750.webp 750w, /banner/banner-1500.webp 1500w, /banner/banner-3000.webp 3000w"
          sizes="(max-width: 1500px) 100vw, 1500px"
        />
        <img
          src="/Banner-website.jpeg"
          alt="Banner"
          width={3840}
          height={930}
          fetchpriority="high"
          decoding="async"
          className={styles.banner_image}
        />
      </picture>
    </div>
  );
};

export default BannerWebsite;
